<mat-toolbar>
  <span><a [routerLink]="['/data/modbusrtu']">MODBUSRTU</a>&nbsp;</span>
  <span> / {{item && item.id ? item.id : 'New'}}</span>
  <span class="toolbar-spacer"></span>
  @if (item && item.id) {
    <button mat-raised-button color="warn" (click)="onDeleteItemClick()">Delete ModbusRTU</button>
  }
  <button mat-raised-button color="primary" (click)="saveItem()" class="ms-2">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>

@if (item) {
  <div class="row my-3">
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>TYPE</mat-label>
        <mat-select [(ngModel)]="item.type" required (ngModelChange)="onTypeChange()">
          @for (type of types; track type) {
            <mat-option [value]="type.id">{{type.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>ATTRIBUTE</mat-label>
        <mat-select [(ngModel)]="item.attribute">
          @for (attr of attributes; track attr) {
            <mat-option [value]="attr.id">{{attr.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>MEASURE</mat-label>
        <mat-select [(ngModel)]="item.measure">
          @for (m of measures; track m) {
            <mat-option [value]="m.id">{{m.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-2">
      <mat-form-field class="w-100">
        <mat-label translate>MULTIPLIER</mat-label>
        <input type="number" matInput [(ngModel)]="item.multiplier">
      </mat-form-field>
    </div>
    <div class="col-md-2">
      <mat-form-field class="w-100">
        <mat-label translate>CONST_OFFSET</mat-label>
        <input type="number" matInput [(ngModel)]="item.constoffset">
      </mat-form-field>
    </div>
    <div class="col-md-2">
      <mat-form-field class="w-100">
        <mat-label translate>LENGTH</mat-label>
        <input type="text" matInput [(ngModel)]="item.length">
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label translate>DATATYPE</mat-label>
        <mat-select [(ngModel)]="item.datatype">
          @for (m of dataTypes; track m) {
            <mat-option [value]="m.id">{{m.id}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label translate>ADDRESS</mat-label>
        <input type="text" matInput [(ngModel)]="item.address" required>
      </mat-form-field>
    </div>
    @if (item.id) {
      <div class="col-md-3">
        <mat-form-field class="w-100">
          <mat-label>Módosította</mat-label>
          <input type="text" matInput [(ngModel)]="item.modifiedBy" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
    @if (item.id) {
      <div class="col-md-3">
        <mat-form-field class="w-100">
          <mat-label>Módosítva</mat-label>
          <input type="text" matInput [(ngModel)]="item.modified" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-select [(ngModel)]="item.counter">
          <mat-option [value]="0" ><span translate>IS_INSTANT</span></mat-option>
          <mat-option [value]="1" ><span translate>IS_COUNTER</span></mat-option>
          <mat-option [value]="2" ><span translate>IS_AVG</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-checkbox [(ngModel)]="item.enabled" color="primary"><span translate>IS_ENABLED</span></mat-checkbox>
    </div>
  </div>
}
